import React, { useEffect, useMemo, useState } from 'react';
import TableComponent from 'app/components/TableComponent';
import { FormControl, Modal } from 'react-bootstrap-v5';
import './styles/ajustes.css';
import { formatDecimal, toaster } from 'app/utilities/commons';
import {
  createAndUpdateDisabilities,
  createAndUpdateFault,
  getAllCollaboratorSettings,
  getAllCollaboratorSettingsName,
  getAllCollaboratorSettingsNumber,
  putRequestOpeningSettings,
} from 'app/service/ajustes/CollaboratorSettings';
import { KTSVG } from '_metronic/helpers';
import * as Yup from 'yup';
import { useFormik } from 'formik';
import axios from 'axios';
import {
  getCollaboratorPerceptions,
  getCollaboratorPerceptionsSecondRosterSettings,
  getCollaboratorPerceptionsSettings,
  deleteCollaboratorPerceptionSecondRoster,
} from 'app/service/perception/perception';
import { Perception } from 'app/types/perceptions';
import Perceptions from 'app/pages/collaborators/components/sections/Perception';
import {
  getCollaboratorDeductionsSecondRosterSettings,
  getCollaboratorDeductionsSettings,
  deleteCollaboratorDeductionSecondRoster,
} from 'app/service/deductions/deductions';
import PerceptionsSettings from './PerceptionSettings';
import { Collaborator, CollaboratorResponse } from 'app/types/collaborator';
import DeductionsSettings from './DeductionsSettings';
import { useSelector } from 'react-redux';
import { RootState } from 'setup';
import { decodeToken } from 'app/utilities/decodeJWTToken';
import { invalidChar } from 'app/utilities/invalidChar';
import Swal from 'sweetalert2';
const API_URL = process.env.REACT_APP_API_NET;

type CollaboratorSettings = {
  collaboratorId?: number;
  collaboratorFaultId?: number;
  numberEmployee: string;
  fullName: string;
  salaryDayli: number;
  daysWork: number;
  faults: number;
  disabilities: number;
  labored: number;
  salary: number;
  perceptions: number;
  deductions: number;
  salaryTotal: number;
  finalizadoBy: number;
  finalizadoDate: string;
};

type CollaboratorPerception = {
  collaborator: string;
  collaboratorId: number;
  createdAt: string;
  id: number;
  perception: string;
  perceptionId: number;
  status: string;
  statusId: number;
  typeMovement: string;
  typeMovementId: number;
  updatedAt: string;
  value: number;
};

type CollaboratorDeduction = {
  collaborator: string;
  collaboratorId: number;
  createdAt: string;
  id: number;
  deduction: string;
  deductionId: number;
  status: string;
  statusId: number;
  typeMovement: string;
  typeMovementId: number;
  updatedAt: string;
  value: number;
};

type InputFields = {
  name: JSX.Element;
  number: JSX.Element;
};

const FaultsSchema = Yup.object().shape({
  days: Yup.number()
    .required('Este campo es requerido.')
    .min(1, 'El campo debe ser mayor a 0')
    .max(3, 'El campo debe ser menor o igual a 3'),
  description: Yup.string()
    .required('Este campo es requerido.')
    .min(1, 'Mínimo 1 caractere')
    .max(100, 'Máximo 100 caracteres'),
});

const DisabilitiesSchema = Yup.object().shape({
  days: Yup.number()
    .required('Este campo es requerido.')
    .min(1, 'El campo debe ser mayor a 0')
    .max(3, 'El campo debe ser menor o igual a 3'),
  description: Yup.string()
    .required('Este campo es requerido.')
    .min(1, 'Mínimo 1 caractere')
    .max(100, 'Máximo 100 caracteres'),
});

const heads = [
  { code: 'numberEmployee', label: 'No. Empleado' },
  { code: 'fullName', label: 'Nombre' },
  { code: 'salaryDayli', label: 'Sueldo Diario' },
  { code: 'daysWork', label: 'Días Lab' },
  { code: 'faults', label: 'Faltas' },
  { code: 'disabilities', label: 'Incapacidades' },
  { code: 'salary', label: 'Sueldo' },
  { code: 'perceptions', label: 'Percepciones' },
  { code: 'deductions', label: 'Deducciones' },
];

const AjusteNominaView: React.FC = () => {
  const [collaborator, setCollaborator] = useState<Collaborator | undefined>();
  const [collaboratorId, setCollaboratorId] = useState<number>();

  const [employeeName, setEmployeeName] = useState('');
  const [employeeNumber, setEmployeeNumber] = useState('');
  const [selectedOption, setSelectedOption] = useState('');
  const [isFiltered, setIsFiltered] = useState<boolean>(false);

  const filterOptions = [
    { id: '1', fecha: 'Nombre', field: 'name' },
    { id: '2', fecha: 'Número de Empleado', field: 'number' },
  ];

  const [showFaltasModal, setShowFaltasModal] = useState(false);
  const [showIncapacidadesModal, setShowIncapacidadesModal] = useState(false);
  const [showPercepcionesModal, setShowPercepcionesModal] = useState(false);
  const [showConceptoModal, setShowConceptoModal] = useState(false);
  const [showDeduccionesModal, setShowDeduccionesModal] = useState(false);
  const [showConceptoDosModal, setShowConceptoDosModal] = useState(false);

  const handleShowConceptoDosModal = () => setShowConceptoDosModal(true);
  const handleCloseConceptoDosModal = () => setShowConceptoDosModal(false);

  const handleShowDeduccionesModal = () => setShowDeduccionesModal(true);
  const handleCloseDeduccionesModal = () => setShowDeduccionesModal(false);

  const handleShowConceptoModal = () => setShowConceptoModal(true);
  const handleCloseConceptosModal = () => setShowConceptoModal(false);

  const handleShowFaltasModal = () => setShowFaltasModal(true);
  const handleCloseFaltasModal = () => setShowFaltasModal(false);

  const handleShowIncapacidadesModal = () => setShowIncapacidadesModal(true);
  const handleCloseIncapacidadesModal = () => setShowIncapacidadesModal(false);

  const handleShowPercepcionesModal = () => setShowPercepcionesModal(true);
  const handleClosePercepcionesModal = () => setShowPercepcionesModal(false);

  const handleFilterClose = () => {
    setShowFilterModal(false);
  };

  const handleFilterOpen = () => {
    setShowFilterModal(true);
  };

  const [currentPage, setCurrentPage] = useState<number>(1);
  const [pageSize, setPageSize] = useState<number>(5);
  const [totalRecords, setTotalRecords] = useState<number>(0);

  const [collaboratorSettings, setCollaboratorSettings] = useState<
    CollaboratorSettings[]
  >([]);

  const [loadingGrid, setLoadingGrid] = useState(true);
  const [showFilterModal, setShowFilterModal] = useState(false);

  const [finalizadoBy, setFinalizadoBy] = useState<number>();
  const [finalizadoDate, setFinalizadoDate] = useState<string>();
  const [canSeeAperturaButtons, setCanSeeAperturaButtons] = useState(false);

  useEffect(() => {
    const fetchUserRoles = async () => {
      try {
        const res = await axios.get(`${API_URL}User/${token.nameid}`);
        const userRoles: any[] = res.data.data.roles || [];
        const hasAllowedRole = userRoles.some(
          (r: any) => r.userRole?.code === 'ADMIN' || r.userRole?.code === 'ADMC'
        );
        setCanSeeAperturaButtons(hasAllowedRole);
      } catch (err) {
        console.error('Error fetching user roles:', err);
      }
    };
    fetchUserRoles();
  }, []);

  const fetchCollaboratorSettings = async () => {
    try {
      const res = await getAllCollaboratorSettings(currentPage, pageSize);
      setCollaboratorSettings(
        res!.records.map((record) => ({
          ...record,
        }))
      );

      setFinalizadoDate(res!.records[0].finalizadoDate)
      setFinalizadoBy(res!.records[0].finalizadoBy)

      setTotalRecords(res!.totalRecords);
      setLoadingGrid(false);
    } catch (err) {
      console.error('Error fetching collaborator settings', err);
    }
  };
  const accessToken: any = useSelector<RootState>(
    (state) => state.auth.accessToken
  );
  const token: any = decodeToken(accessToken);

  const isAuthorizeBtnDisabled = useMemo(() => {
    return collaboratorSettings.length === 0 || collaboratorSettings.some((record) => record.finalizadoDate);
  }, [collaboratorSettings]);

  const fetchBondsDepartmentsCollaboratorFilterByNumber = async (
    employeeNumber: any
  ) => {
    setIsFiltered(true);
    try {
      const res = await getAllCollaboratorSettingsNumber(
        currentPage,
        pageSize,
        employeeNumber
      );
      setCollaboratorSettings(
        res!.records.map((record) => ({
          ...record,
        }))
      );
      setTotalRecords(res!.totalRecords);
      setLoadingGrid(false);
    } catch (err) {
      console.error('Error al obtener los datos');
    }
  };

  const finalizedSettings = async (idUser: number, idPeriod: number) => {
    try {
      const res = await axios.get(`${API_URL}Settings/SettingsFinal?Id_user=${idUser}&Id_period=${idPeriod}`);
      fetchCollaboratorSettings();
      toaster.success(res.data.data.mensaje);
    } catch (err) {
      console.error("Error finalizing settings on Ajustes")
    }
  }

  const handleSelectChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
    setSelectedOption(e.target.value);
  };

  const fetchBondsDepartmentsCollaboratorFilterByName = async (
    employeeName: any
  ) => {
    setIsFiltered(true);
    try {
      const res = await getAllCollaboratorSettingsName(
        currentPage,
        pageSize,
        employeeName
      );
      setCollaboratorSettings(
        res!.records.map((record) => ({
          ...record,
        }))
      );
      setTotalRecords(res!.totalRecords);
      setLoadingGrid(false);
    } catch (err) {
      console.error('Error al obtener los datos');
    }
  };

  const handleSearch = () => {
    if (selectedOption === '1' && employeeName) {
      setIsFiltered(true);
      setCurrentPage(1);
      fetchBondsDepartmentsCollaboratorFilterByName(employeeName);
    } else if (selectedOption === '2' && employeeNumber) {
      setIsFiltered(true);
      setCurrentPage(1);
      fetchBondsDepartmentsCollaboratorFilterByNumber(employeeNumber);
    }
  };


  useEffect(() => {
    if (isFiltered) {
      if (selectedOption === '1' && employeeName) {
        fetchBondsDepartmentsCollaboratorFilterByName(employeeName);
      } else if (selectedOption === '2' && employeeNumber) {
        fetchBondsDepartmentsCollaboratorFilterByNumber(employeeNumber);
      }
    } else {
      fetchCollaboratorSettings();
    }
  }, [currentPage, pageSize, isFiltered]);


  const formFaults = useFormik<any>({
    validationSchema: FaultsSchema,
    initialValues: {
      days: 0,
      description: '',
    },
    onSubmit: async (values, { setSubmitting }) => {
      try {
        await createAndUpdateFault({
          ...values,
          comments: values?.description,
          periodId: periodId,
          collaboratorId: collaboratorId,
        });
        toaster.success('Se cambio con éxito la información');
        setShowFaltasModal(false);
        fetchCollaboratorSettings();
        formFaults.resetForm();
      } catch (err) {
        console.error('Error', err);
      } finally {
        setSubmitting(false);
      }
    },
  });

  const formDisabilities = useFormik<any>({
    validationSchema: DisabilitiesSchema,
    initialValues: {
      days: 0,
      description: '',
    },
    onSubmit: async (values, { setSubmitting }) => {
      try {
        await createAndUpdateDisabilities({
          ...values,
          comments: values?.description,
          periodId: periodId,
          collaboratorId: collaboratorId,
        });
        toaster.success('Se cambio con éxito la información');
        setShowIncapacidadesModal(false);
        fetchCollaboratorSettings();
        formDisabilities.resetForm();
      } catch (err) {
        console.error('Error', err);
      } finally {
        setSubmitting(false);
      }
    },
  });

  const [periodStatusId, setPeriodsStatusId] = useState();
  const [periodId, setPeriodID] = useState<any>();
  const fetchPeriods = async () => {
    try {
      const res = await axios.get(`${API_URL}Period`);
      const filteredPeriod = res.data.data.records.filter(
        (record: { statusId: number }) => record.statusId === 1
      );
      setPeriodID(filteredPeriod[0].id);
      setPeriodsStatusId(filteredPeriod[0].statusId);
    } catch (err) {
      console.error('Error al obtener los periodos:', err);
    }
  };
  useEffect(() => {
    fetchPeriods();
  }, []);

  const fetchProfiles = async (
    id: number | string | undefined,
  ) => {
    try {
      const res = await axios.get<CollaboratorResponse>(
        `${API_URL}Collaborator/${id}`
      );
      setCollaborator(res.data.data);
    } catch (error) {
      console.error('Error fetching positions:', error);
    }
  };

  const [collaboratorPerception, setCollaboratorPerception] = useState<
    CollaboratorPerception[]
  >([]);
  const [
    collaboratorPerceptionSecondRoster,
    setCollaboratorPerceptionSecondRoster,
  ] = useState<CollaboratorPerception[]>([]);
  const fetchCollaboratorPerceptionsId = async (
    id: number | string | undefined
  ) => {
    try {
      const res = await getCollaboratorPerceptionsSettings(id);
      const transformedDataList = res.map((record: CollaboratorPerception) => ({
        ...record,
      }));
      setCollaboratorPerception(transformedDataList);
      const res1 = await getCollaboratorPerceptionsSecondRosterSettings(id, periodId);
      const transformedDataSecondRoster = (res1 ?? []).map(
        (record: CollaboratorPerception) => ({
          ...record,
        })
      );
      setCollaboratorPerceptionSecondRoster(transformedDataSecondRoster);
    } catch (err) {
      console.error('Error fetching collaborator perception id', err);
    }
  };

  const handleDeletePerception = async (id: number) => {
    try {
      await deleteCollaboratorPerceptionSecondRoster(id);
      toaster.success('Se eliminó la percepción con éxito');
      fetchCollaboratorPerceptionsId(collaboratorId);
      fetchCollaboratorSettings();
    } catch (error: any) {
      console.error('Error deleting collaborator perception', error);
      toaster.error(error.message ?? 'Hubo un error al intentar eliminar la percepción');
    }
  };

  const handleDeleteDeduction = async (id: number) => {
    try {
      await deleteCollaboratorDeductionSecondRoster(id);
      toaster.success('Se eliminó la deducción con éxito');
      fetchCollaboratorDeductionsId(collaboratorId);
      fetchCollaboratorSettings();
    } catch (error: any) {
      console.error('Error deleting collaborator deduction', error);
      toaster.error(error.message ?? 'Hubo un error al intentar eliminar la deducción');
    }
  };

  const handleRequestOpeningSettings = async () => {
    try {
      await putRequestOpeningSettings(token.nameid, periodId);
      toaster.success('Apertura de Ajustes realizada con éxito');
      fetchCollaboratorSettings();
    } catch (err: any) {
      console.error('Error on Request Opening Settings:', err);
      toaster.error(err.message ?? 'Hubo un error al realizar la apertura de ajustes');
    }
  };

  /**
   * Clean all the filters, inputs and fetch again the data
   */
  const handleClearFilters = () => {
    setEmployeeNumber('');
    setEmployeeName('');
    setSelectedOption('');
    setIsFiltered(false);
    setCurrentPage(1);
    fetchCollaboratorSettings();
  }

  const [collaboratorDeduction, setCollaboratorDeduction] = useState<
    CollaboratorDeduction[]
  >([]);
  const [
    collaboratorDeductionSecondRoster,
    setCollaboratorDeductionSecondRoster,
  ] = useState<CollaboratorDeduction[]>([]);

  const fetchCollaboratorDeductionsId = async (
    id: number | string | undefined
  ) => {
    try {
      const res = await getCollaboratorDeductionsSettings(id);
      const transformedData = res.map((record: CollaboratorDeduction) => ({
        ...record,
      }));
      setCollaboratorDeduction(transformedData);

      const res1 = await getCollaboratorDeductionsSecondRosterSettings(id, periodId);
      const transformedDataSecondRoster = (res1 ?? []).map(
        (record: CollaboratorDeduction) => ({
          ...record,
        })
      );
      setCollaboratorDeductionSecondRoster(transformedDataSecondRoster);
    } catch (err) {
      console.error('Error fetching collaborator perception id', err);
    }
  };

  const inputFields: InputFields = {
    name: (
      <>
        <div className="mt-4">
          <label className="form-label fw-bold">Nombre: </label>
        </div>
        <div>
          <input
            type="text"
            value={employeeName}
            className="form-control mt-4"
            onChange={(e) => setEmployeeName(e.target.value)}
          />
          <div className="mt-4 d-flex flex-row-reverse">
            <button
              type="submit"
              className="btn btn-primary"
              data-kt-menu-dismiss="true"
              onClick={(e) => {
                e.preventDefault();
                handleSearch();
                handleFilterClose();
              }}
            >
              Buscar
            </button>
            <button
              type="reset"
              className="btn btn-white btn-active-light-primary me-2"
              data-kt-menu-dismiss="true"
              onClick={(e) => {
                e.preventDefault();
                handleFilterClose();
                handleClearFilters();
              }}
            >
              Limpiar
            </button>
          </div>
        </div>
      </>
    ),
    number: (
      <>
        <div className="mt-4">
          <label className="form-label fw-bold">Número de Empleado: </label>
        </div>
        <div>
          <input
            type="text"
            value={employeeNumber}
            className="form-control mt-4"
            onChange={(e) => setEmployeeNumber(e.target.value)}
          />
          <div className="mt-4 d-flex flex-row-reverse">
            <button
              type="submit"
              className="btn btn-primary"
              data-kt-menu-dismiss="true"
              onClick={(e) => {
                e.preventDefault();
                handleSearch();
                handleFilterClose();
              }}
            >
              Buscar
            </button>
            <button
              type="reset"
              className="btn btn-white btn-active-light-primary me-2"
              data-kt-menu-dismiss="true"
              onClick={(e) => {
                e.preventDefault();
                handleFilterClose();
                handleClearFilters();
              }}
            >
              Limpiar
            </button>
          </div>
        </div>
      </>
    ),
  };

  const rows = useMemo(() => {
    if (!loadingGrid && collaboratorSettings.length) {
      return collaboratorSettings.map((row) => ({
        numberEmployee: (
          <div style={{ textAlign: 'center' }}>{row.numberEmployee}</div>
        ),
        fullName: <div style={{ textAlign: 'center' }}>{row.fullName}</div>,
        salaryDayli: (
          <div style={{ textAlign: 'center' }}>
            ${formatDecimal.format(row.salaryDayli)}
          </div>
        ),
        daysWork: <div style={{ textAlign: 'center' }}>{row.daysWork}</div>,
        faults: (
          <div
            onClick={() => {
              if (!isAuthorizeBtnDisabled) {
                setCollaboratorId(row.collaboratorId);
                handleShowFaltasModal();
              } else {
                toaster.warning('No se puede modificar la información, ya fueron cerrados los ajustes.');
              }

            }}
            style={{ cursor: 'pointer', color: 'blue' }}
          >
            {row.faults}
          </div>
        ),
        disabilities: (
          <div
            onClick={() => {
              if (!isAuthorizeBtnDisabled) {
                setCollaboratorId(row.collaboratorId);
                handleShowIncapacidadesModal();
              } else {
                toaster.warning('No se puede modificar la información, ya fueron cerrados los ajustes.');
              }

            }}
            style={{ cursor: 'pointer', color: 'blue' }}
          >
            {row.disabilities}
          </div>
        ),
        salary: (
          <div style={{ textAlign: 'center' }}>${formatDecimal.format(row.salary)}</div>
        ),
        perceptions: (
          <div
            onClick={(e) => {
              if (!isAuthorizeBtnDisabled) {
                setCollaboratorId(row.collaboratorId);
                fetchCollaboratorPerceptionsId(row.collaboratorId);
                fetchProfiles(row.collaboratorId);
                handleShowPercepcionesModal();
              } else {
                toaster.warning('No se puede modificar la información, ya fueron cerrados los ajustes.');
              }

            }}
            style={{ cursor: 'pointer', color: 'blue' }}
          >
            ${formatDecimal.format(row.perceptions)}
          </div>
        ),
        deductions: (
          <div
            onClick={(e) => {
              if (!isAuthorizeBtnDisabled) {
                setCollaboratorId(row.collaboratorId);
                fetchCollaboratorDeductionsId(row.collaboratorId);
                fetchProfiles(row.collaboratorId);
                handleShowDeduccionesModal();
              } else {
                toaster.warning('No se puede modificar la información, ya fueron cerrados los ajustes.');
              }

            }}
            style={{ cursor: 'pointer', color: 'blue' }}
          >
            ${formatDecimal.format(row.deductions)}
          </div>
        ),
      }));
    }
    return [];
  }, [collaboratorSettings, loadingGrid, periodId]);

  const fieldToShow = filterOptions.find(
    (option) => option.id === selectedOption
  )?.field;

  const totalValuePerception = collaboratorPerception.reduce(
    (prevValue, currentValue) => prevValue + currentValue.value,
    0
  );
  const totalValueDeduction = collaboratorDeduction.reduce(
    (prevValue, currentValue) => prevValue + currentValue.value,
    0
  );

  return (
    <div className="row gy-5 g-xl-8">
      <div className="col-xxl-12 col-xl-12 col-md-12 col-lg-12">
        <div className="card card-flush p-5">
          <label className="form-label">Cierre de ajustes</label>
          <div className="d-flex justify-content-between mb-5">
            <div className="me-3">
              <input type="text" className="form-control" value={finalizadoDate || 'N/A'} disabled />
            </div>
            <button
              className="btn btn-light-primary border-btn w-10"
              onClick={handleFilterOpen}
            >
              <KTSVG
                path="/media/icons/duotune/general/gen021.svg"
                className="svg-icon svg-icon-5 svg-icon-gray-500"
              />
              <span className="ms-2">Filtrar</span>
            </button>
          </div>

          <TableComponent
            heads={heads}
            rows={rows}
            rowsPerPage={pageSize}
            page={currentPage}
            totalRows={totalRecords}
            setPage={setCurrentPage}
          // isLoading={loadingGrid}
          />

          <div className="d-flex justify-content-between">
            <div>
              {canSeeAperturaButtons && finalizadoDate && (
                <button
                  type="button"
                  className="btn btn-primary"
                  onClick={handleRequestOpeningSettings}
                >
                  Apertura de Ajustes
                </button>
              )}
            </div>
            <div>
              <button
                type="submit"
                className="btn btn-primary"
                disabled={isAuthorizeBtnDisabled}
                onClick={(e) => {
                  e.preventDefault();
                  Swal.fire({
                    title: '¿Desea finalizar los ajustes de nómina?',
                    text: 'Una vez finalizados ya no se podrá modificar ningún dato de estos ajustes.',
                    icon: 'question',
                    showCancelButton: true,
                    padding: '2em',
                    cancelButtonText: 'Cancelar',
                    confirmButtonText: 'Aceptar',
                    reverseButtons: true,
                    customClass: {
                      confirmButton: 'btn btn-primary',
                      cancelButton: 'btn btn-light me-3',
                    },
                  }).then((result) => {
                    if (result.isConfirmed) {
                      finalizedSettings(token.nameid, periodId);
                    }
                  });
                }}
              >
                Finalizar
              </button>
            </div>
          </div>
        </div>
      </div>

      {/* Modal de faltas */}
      <Modal show={showFaltasModal} onHide={handleCloseFaltasModal} centered>
        <Modal.Header closeButton>
          <Modal.Title className="w-100 text-center">Faltas</Modal.Title>
        </Modal.Header>
        <form
          className="form needs-validation"
          noValidate
          onSubmit={formFaults.handleSubmit}
        >
          <Modal.Body>
            <div className="mb-3">
              <label htmlFor="dias-faltas" className="form-label">
                Días
              </label>
              <input
                type="number"
                id="dias-faltas"
                className="form-control"
                min="1"
                max="3"
                name="days"
                value={formFaults.values.days}
                onChange={formFaults.handleChange}
                onKeyDown={invalidChar}
              />
              {formFaults.errors.days && (
                <div className="fv-plugins-message-container text-danger w-100">
                  <span role="alert">{formFaults.errors.days}</span>
                </div>
              )}
            </div>
            <div className="mb-3">
              <label htmlFor="descripcion-faltas" className="form-label">
                Descripción
              </label>
              <textarea
                id="descripcion-faltas"
                className="form-control"
                placeholder="Descripción"
                value={formFaults.values.description}
                onChange={formFaults.handleChange}
                name="description"
                style={{
                  maxHeight: "200px",
                  overflow: "auto",
                  resize: "none",
                }}
              ></textarea>
              {formFaults.errors.description && (
                <div className="fv-plugins-message-container text-danger w-100">
                  <span role="alert">{formFaults.errors.description}</span>
                </div>
              )}
            </div>
          </Modal.Body>
          <Modal.Footer className="d-flex justify-content-between">
            <button
              type="reset"
              className="btn btn-secondary"
              onClick={() => { handleCloseFaltasModal(); formFaults.resetForm(); }}
            >
              Cancelar
            </button>
            <button type="submit" className="btn btn-primary">
              Guardar
            </button>
          </Modal.Footer>
        </form>
      </Modal>

      {/* Modal de incapacidades */}
      <Modal
        show={showIncapacidadesModal}
        onHide={handleCloseIncapacidadesModal}
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title className="w-100 text-center">Incapacidades</Modal.Title>
        </Modal.Header>
        <form
          className="form needs-validation"
          noValidate
          onSubmit={formDisabilities.handleSubmit}
        >
          <Modal.Body>
            <div className="mb-3">
              <label htmlFor="dias-incapacidades" className="form-label">
                Días
              </label>
              <input
                type="number"
                id="dias-incapacidades"
                className="form-control"
                min="1"
                max="3"
                name="days"
                value={formDisabilities.values.days}
                onChange={formDisabilities.handleChange}
                onKeyDown={invalidChar}
              />
              {formDisabilities.errors.days && (
                <div className="fv-plugins-message-container text-danger w-100">
                  <span role="alert">{formDisabilities.errors.days}</span>
                </div>
              )}
            </div>
            <div className="mb-3">
              <label htmlFor="descripcion-incapacidades" className="form-label">
                Descripción
              </label>
              <textarea
                id="descripcion-incapacidades"
                className="form-control"
                placeholder="Descripción"
                value={formDisabilities.values.description}
                onChange={formDisabilities.handleChange}
                name="description"
                style={{
                  maxHeight: "200px",
                  overflow: "auto",
                  resize: "none",
                }}
              ></textarea>
              {formDisabilities.errors.description && (
                <div className="fv-plugins-message-container text-danger w-100">
                  <span role="alert">{formDisabilities.errors.description}</span>
                </div>
              )}
            </div>
          </Modal.Body>
          <Modal.Footer className="d-flex justify-content-between">
            <button
              type="reset"
              className="btn btn-secondary"
              onClick={() => { handleCloseIncapacidadesModal(); formDisabilities.resetForm(); }}
            >
              Cancelar
            </button>
            <button type="submit" className="btn btn-primary">
              Guardar
            </button>
          </Modal.Footer>
        </form>
      </Modal>
      {/* Modal de percepciones */}
      <Modal
        show={showPercepcionesModal}
        onHide={handleClosePercepcionesModal}
        centered
        size="lg"
      >
        <Modal.Header closeButton>
          <Modal.Title className="text-center w-100">
            Percepciones de nómina
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="d-flex align-items-start mb-8">
            {/* Tabla de percepciones capturadas */}
            <div className="flex-grow-1 me-3">
              <h3 className="fw-bold">Percepciones Fijas</h3>
              <table className="table table-bordered text-center align-middle">
                <thead className="table-light">
                  <tr>
                    <th style={{ width: '66%' }}>Concepto</th>
                    <th style={{ width: '35%' }}>Valor</th>
                  </tr>
                </thead>
                <tbody>
                  {collaboratorPerception.map((item) => (
                    <tr key={item.id}>
                      <td>{item.perception}</td>
                      <td>{item.value.toFixed(2)}</td>
                    </tr>
                  ))}
                  <tr className="border p-3 text-center bg-light rounded fw-bolder">
                    <td>Total</td>
                    <td>{totalValuePerception.toFixed(2)}</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
          {/* Tabla de percepciones agregadas */}
          <div className="mb-3">
            <h3 className="fw-bold">Percepciones agregadas en este periodo</h3>
            <section style={{ maxHeight: "15rem", overflowY: "scroll" }}>
              <table className="table table-bordered text-center align-middle">
                <thead className="table-light">
                  <tr>
                    <th style={{ width: '55%' }}>Concepto</th>
                    <th style={{ width: '35%' }}>Valor</th>
                    <th style={{ width: '10%' }}>Acciones</th>
                  </tr>
                </thead>
                <tbody>
                  {collaboratorPerceptionSecondRoster.map((item) => (
                    <tr key={item.id}>
                      <td>{item.perception}</td>
                      <td>{item.value.toFixed(2)}</td>
                      <td>
                        <div
                          style={{ cursor: 'pointer' }}
                          onClick={() => handleDeletePerception(item.id)}
                        >
                          <KTSVG
                            path="/media/icons/duotune/general/gen027.svg"
                            className="svg-icon-3 svg-icon-danger"
                          />
                        </div>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </section>
          </div>
          {/* Botón para agregar conceptos */}
          <div className="mb-3">
            <button
              className="btn btn-light w-100"
              onClick={handleShowConceptoModal}
            >
              + Agregar Percepción
            </button>
          </div>
        </Modal.Body>
        {/* Footer */}
        <Modal.Footer className="d-flex justify-content-between">
          <button
            type="button"
            className="btn btn-secondary"
            onClick={handleClosePercepcionesModal}
          >
            Cerrar
          </button>
        </Modal.Footer>
      </Modal>

      {/*modal de concepto */}
      <Modal
        show={showConceptoModal}
        onHide={handleCloseConceptosModal}
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title className="w-100 text-center">Percepciones</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <PerceptionsSettings
            collaborator={collaborator}
            handleCloseModal={handleCloseConceptosModal}
            fetchCollaboratorPerceptionsId={fetchCollaboratorPerceptionsId}
            fetchCollaboratorSettings={fetchCollaboratorSettings}
            periodId={periodId}
          />
        </Modal.Body>
      </Modal>

      {/* Modal de deducciones */}
      <Modal
        show={showDeduccionesModal}
        onHide={handleCloseDeduccionesModal}
        centered
        size="lg"
      >
        <Modal.Header closeButton>
          <Modal.Title className="text-center w-100">
            Deduccion de nómina
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <h3 className="fw-bold">Deducciones fijas</h3>
          <div className="d-flex align-items-start mb-8">
            {/* Tabla de percepciones capturadas */}
            <div className="flex-grow-1 me-3">
              <table className="table table-bordered text-center align-middle">
                <thead className="table-light">
                  <tr>
                    <th>Concepto</th>
                    <th>Valor</th>
                  </tr>
                </thead>
                <tbody>
                  {collaboratorDeduction.map((item) => (
                    <tr key={item.id}>
                      <td>{item.deduction}</td>
                      <td>{item.value.toFixed(2)}</td>
                    </tr>
                  ))}
                  <tr className="border p-3 text-center bg-light rounded fw-bolder">
                    <td>Total</td>
                    <td>{totalValueDeduction.toFixed(2)}</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
          {/* Tabla de percepciones agregadas */}
          <div className="mb-3">
            <h3 className="fw-bold">Deducciones agregadas en este periodo</h3>
            <section style={{ maxHeight: "15rem", overflowY: "scroll" }}>
              <table className="table table-bordered text-center align-middle">
                <thead className="table-light">
                  <tr>
                    <th style={{ width: '55%' }}>Concepto</th>
                    <th style={{ width: '35%' }}>Valor</th>
                    <th style={{ width: '10%' }}>Acciones</th>
                  </tr>
                </thead>
                <tbody>
                  {collaboratorDeductionSecondRoster.map((item) => (
                    <tr key={item.id}>
                      <td >{item.deduction}</td>
                      <td >{item.value.toFixed(2)}</td>
                      <td>
                        <div
                          style={{ cursor: 'pointer' }}
                          onClick={() => handleDeleteDeduction(item.id)}
                        >
                          <KTSVG
                            path="/media/icons/duotune/general/gen027.svg"
                            className="svg-icon-3 svg-icon-danger"
                          />
                        </div>
                      </td>
                    </tr>
                  ))}

                </tbody>
              </table>
            </section>
          </div>
          {/* Botón para agregar conceptos */}
          <div className="mb-3">
            <button
              className="btn btn-light w-100"
              onClick={handleShowConceptoDosModal}
            >
              + Agregar Deducción
            </button>
          </div>
        </Modal.Body>
        {/* Footer */}
        <Modal.Footer className="d-flex justify-content-between">
          <button
            type="button"
            className="btn btn-secondary"
            onClick={handleCloseDeduccionesModal}
          >
            Cerrar
          </button>
        </Modal.Footer>
      </Modal>
      {/* Concepto dos de deducción */}
      <Modal
        show={showConceptoDosModal}
        onHide={handleCloseConceptoDosModal}
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title className="w-100 text-center">Deducciones</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <DeductionsSettings
            collaborator={collaborator}
            handleCloseModal={handleCloseConceptoDosModal}
            fetchCollaboratorDeductionsId={fetchCollaboratorDeductionsId}
            fetchCollaboratorSettings={fetchCollaboratorSettings}
            periodId={periodId}
          />
        </Modal.Body>
      </Modal>

      {/* Modal de filtro */}
      <Modal
        id="kt_modal_filter"
        tabIndex={-1}
        aria-hidden="true"
        dialogClassName="modal-dialog"
        show={showFilterModal}
        onHide={handleFilterClose}
      >
        <div className="modal-content">
          <div className="modal-header">
            <h1 className="text-muted mx-5">Filtrar Resultados</h1>
            <div
              className="btn btn-sm btn-icon btn-active-color-primary"
              onClick={handleFilterClose}
            >
              <KTSVG
                className="svg-icon-2"
                path="/media/icons/duotune/arrows/arr061.svg"
              />
            </div>
          </div>
          <div className="modal-body mx-5 padding-top-00">
            <div className="mt-4">
              <label className="form-label fw-bold">
                Seleccione una opción:
              </label>
            </div>
            <select
              className="form-select"
              value={selectedOption}
              onChange={handleSelectChange}
            >
              <option value="">Seleccione</option>
              {filterOptions.map((option) => (
                <option key={option.id} value={option.id}>
                  {option.fecha}
                </option>
              ))}
            </select>
            {fieldToShow && inputFields[fieldToShow as keyof InputFields]}
          </div>
          <div className="modal-body mx-5 padding-top-00"></div>
        </div>
      </Modal>
    </div>
  );
};

export { AjusteNominaView };
